import { render, staticRenderFns } from "./PPP3Forms.vue?vue&type=template&id=ff30e2a6"
import script from "./PPP3Forms.vue?vue&type=script&lang=js"
export * from "./PPP3Forms.vue?vue&type=script&lang=js"
import style0 from "./PPP3Forms.vue?vue&type=style&index=0&id=ff30e2a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports